module.exports = __webpack_public_path__ + "static/ReadilyAvailable-224aca546863882a82283ee24d68e5f1.svg";